import { State } from 'vuex-simple';
import { spriteDefinitionsUrl } from '@/Common/Environment/const';
import BaseBundlerModule from '@/HostApp/services/CSSBundler/BaseBundlerModule';

export class SpriteBundlerModule extends BaseBundlerModule {
	private readonly storage: Map<string, Promise<HTMLDivElement>>;

	constructor(mode: RequestMode = 'cors') {
		super(mode);
		this.storage = new Map();
	}

	@State()
	public loading: boolean = false;

	@State()
	public api: Partial<SpriteBundlerModule> = {
		attachSprite: (el: HTMLBodyElement | null) => {
			return this.attachSprite(el);
		},

		prefetchSprites: (urls: Array<string> = []) => {
			return this.prefetchSprites(urls);
		}
	};

	public prefetchSprites(urls: Array<string> = [spriteDefinitionsUrl]): void {
		this.fetchUrls(urls, this.storage, this.createSpriteNode);
	}

	public attachSprite(
		el: HTMLBodyElement | ShadowRoot | null,
		urls: Array<string> = [spriteDefinitionsUrl]
	): Promise<void> {
		if (el) {
			this.loading = true;
			const loadedSprites = this.fetchUrls(urls, this.storage, this.createSpriteNode);
			return Promise.all(loadedSprites)
				.then((loadedSprites) => {
					loadedSprites.forEach((spriteNode) => {
						el.appendChild(spriteNode.cloneNode(true));
					});
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					console.warn(`Something went wrong, cannot inject SVG Sprites: `, e);
				})
				.finally(() => {
					this.loading = false;
				});
		}
		return Promise.resolve();
	}

	protected createSpriteNode(data: Promise<string>): Promise<HTMLDivElement> {
		return data.then((cssText) => {
			const target = document.createElement('div');
			target.style.display = 'none';
			target.classList.add('__SVG_SPRITE_NODE__');
			target.innerHTML = cssText;

			return target;
		});
	}
}

const spriteBundlerModule = new SpriteBundlerModule();

export default spriteBundlerModule;
